module.exports = __webpack_public_path__ + "media/question3_en.f4a74fe1.wav";